var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex h-100 align-items-center bg-white"
  }, [_vm._m(0), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('div', {
    staticClass: "code ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('not-found.404')) + " ")]), _c('div', {
    staticClass: "description ml-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('not-found.description')) + " ")]), _c('b-button', {
    staticClass: "mt-5",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('not-found.home')) + " ")])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-end cat-wrapper"
  }, [_c('div', {
    staticClass: "cat"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/not-found/Cica404.png"),
      "alt": "Cat404"
    }
  })])]);

}]

export { render, staticRenderFns }